module.exports = "/_next/static/videos/seller-1-581c993f84a73cb3382ccf6fa9818fd2.mp4";